#### Migrating from GraphQL Playground to GraphQL Explorer

We have added the ability to instantly run queries and mutations against the Playground environment from within the Developer Dashboard.
Previously, you would’ve had to manually [request a partner token] and enter it on the GraphQL Playground.

This new feature replaces [https://graphql.seek.com/graphql] with [https://developer.seek.com/manage/graphql-explorer](/manage/graphql-explorer) for querying the Playground environment.

If you were using [https://graphql.seek.com/graphql] with live credentials, we recommend switching to Postman or another similar tool.

[request a partner token]: /graphql/playground#authentication
[https://graphql.seek.com/graphql]: https://graphql.seek.com/graphql
